import React, { useEffect, useState } from 'react'

import { useParams } from 'react-router-dom'

import Doctor from '../../../../../presentation/pages/contractors/doctor'
import Loading from '../../../../../presentation/components/loading'

import { useResource } from '../../../../../presentation/hooks/resource'
import { useFetchResource } from '../../../../../presentation/hooks/fetch-resource'
import { useMap } from '../../../../../presentation/hooks/map'
import { useMe } from '../../../../../presentation/contexts/me'

import { makeDoctors } from '../../../../usecases/doctors/remote-doctors-factory'
import {
  makeContractorsContracts,
  makeDoctorsContracts,
} from '../../../../usecases/contracts/remote-contracts-factory'

import IDoctor from '../../../../../presentation/interfaces/doctor'

import transformAvailability from '../../../../../presentation/helpers/helper-transform-availability'

const MakeDoctor = () => {
  document.title = 'BuscarMédicos - Médico'

  const [contracts, setContracts] = useState<IDoctor[]>([])

  const { id } = useParams<{ id: string }>()

  const { me } = useMe()

  const [, doctorService, _doctor, loading] = useResource(makeDoctors())

  const isContracted = contracts.some(
    (contract: any) => contract.name === `${_doctor?.firstName} ${_doctor?.lastName}`,
  )

  useFetchResource(doctorService.loadById, Number(id))

  useEffect(() => {
    const fetchContracts = async () => {
      if (me) {
        const res = await makeContractorsContracts(me.id).load()
        setContracts(res)
      }
    }

    fetchContracts()
  }, [me])

  const { location } = useMap(_doctor?.address)

  const handleContract = async () => {
    if (me?.id && id) {
      await makeDoctorsContracts(Number(id)).post({
        contractor: me.id,
      })

      const res = await makeContractorsContracts(me.id).load()
      setContracts(res)
    }
  }

  if (loading) {
    return <Loading />
  }

  if (!_doctor) {
    return null
  }

  const availability = transformAvailability(_doctor?.availability)

  const doctor = {
    ..._doctor,
    chatId: id,
    availability,
    pdfUrl: _doctor.document.find((doc: any) => doc.url.startsWith('documents/'))?.url,
  }

  const doctorProps = {
    doctor,
    location,
    isContracted,
    handleContract,
  }

  return <Doctor {...doctorProps} />
}

export default MakeDoctor
